import { createStore } from "solid-js/store";
import { useApplication } from "@/context/app";
import { change } from "../../requests/password";
import { createSignal, onMount } from "solid-js";
export default function useUpdateProfile(onModalClose) {
  const [loading, setLoading] = createSignal(false);
  const [fetching, setFetching] = createSignal(false);
  const [form, setForm] = createStore({
    oldPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  onMount(async () => {
    try {
      setFetching(true);
    } catch (error) {

    } finally {
      setFetching(false);
    }
  });

  const { successToast, errorToast } = useApplication();

  const onFormInput = (name, value) => {
    setForm([name], value);
  };

  const updatePassword = async () => {
    setLoading(true);
    try {
      const data = await change({
        ...form
      });

      successToast(data.message);
      setForm('oldPassword', '');
      setForm('newPassword', '');
      setForm('confirmPassword', '');
      onModalClose();
    } catch (error) {
      errorToast(error);
    } finally {
      setLoading(false);
    }
  };
  return {
    loading,
    fetching,
    form,
    updatePassword,
    onFormInput
  };
}
